import { render } from "./AposCommandMenuKey.vue?vue&type=template&id=5f741340&scoped=true"
import script from "./AposCommandMenuKey.vue?vue&type=script&lang=js"
export * from "./AposCommandMenuKey.vue?vue&type=script&lang=js"

import "./AposCommandMenuKey.vue?vue&type=style&index=0&id=5f741340&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f741340"],['__file',"command-menu/ui/apos/components/AposCommandMenuKey.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f741340"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f741340', __exports__)) {
    api.reload('5f741340', __exports__)
  }
  
  module.hot.accept("./AposCommandMenuKey.vue?vue&type=template&id=5f741340&scoped=true", () => {
    api.rerender('5f741340', render)
  })

}


export default __exports__